import React from 'react';

import { Segment, Form, Message } from 'semantic-ui-react';

import EditDialog from '../components/EditDialog';

import PropTypes from 'prop-types';

const INITIAL_STATE = {
  name: '',
  memberemail: '',
  vote: false,

  errors: {
    error: false
  }
};

class MemberEditDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE, ...this.props.member };

    this.didChange = this.didChange.bind(this);
    this.validate = this.validate.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  handleChange = (event, { name, value }) => {
    this.setState({ [name]: value });
  }

  handleVoteChange = (event, { name, value }) => {
    let stateUpdate = { [name]: value };

    this.setState(stateUpdate, () => { this.validate(); });
  }

  didChange = () => {
    return true;
  }

  validate = () => {
    if (this.state.errors.error) {
      this.isValid()
    }
  }

  isValid = () => {
    let errors = { error: false };

    if (!this.state.name) {
      errors.error = true;
      errors.name = 'Please enter a name. ';
    }

    if (!this.state.memberemail) {
      errors.error = true;
      errors.memberemail = 'Please enter a valid email address. ';
    }

    if (this.state.vote === '') {
      errors.error = true;
      errors.vote = 'Please vote Yes or No.';
    }

    this.setState({ errors: errors });

    return !errors.error;
  }

  onSave = () => {
    const { errors, ...state } = this.state;
    this.props.onSave('members', { ...state });
  }

  render = () => {
    const { onSave, onClose, member, ...props } = this.props;

    const types = [{ key: 'T', value: true, text: 'Yes' }, { key: 'F', value: false, text: 'No' }];

    return (
      <EditDialog size='large' header='Edit Member' onSave={ this.onSave } onClose={ onClose } readOnly={ this.props.disabled }
        isValid={ this.isValid } didChange={ this.didChange } error={ this.state.errors.error } { ...props }
      >
        <Segment.Group size='large'>
          <Segment disabled={ this.props.disabled }>
            <Form.Group>
              <Form.Input readOnly={ this.props.disabled } required={ !this.props.disabled } width={ 6 }
                label='Name' value={ this.state.name } name='name'
                onChange={ this.handleChange }
              />
              <Form.Input readOnly={ this.props.disabled } required={ !this.props.disabled } width={ 6 }
                label='Email' value={ this.state.memberemail } name='memberemail'
                onChange={ this.handleChange }
              />
              { this.props.disabled &&
                <Form.Input readOnly label='Type' value={ this.state.vote ? 'Yes' : 'No' } width={ 4 }/>
              }
              { !this.props.disabled &&
                <Form.Select required label='Vote Option' name='vote' value={ this.state.vote } options={ types } width={ 4 }
                  error={ !!this.state.errors.vote }
                  onChange={ this.handleVoteChange }
                />
              }
            </Form.Group>
            <Message error>
              { this.state.errors.name }{ this.state.errors.memberemail }{ this.state.errors.vote }
            </Message>
          </Segment>
        </Segment.Group>
      </EditDialog>
    );
  }
}

MemberEditDialog.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  member: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default MemberEditDialog;
